import React, { Component } from 'react'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
// import insight1 from '../../assets/image/insight1.jpg'
// import twitter from '../../assets/image/twitter.png'
// import fb from '../../assets/image/fb.png'
// import linkedin from '../../assets/image/linkedin.png'
import Fb from '../../assets/image/sosmed/facebook.png'
import Ig from '../../assets/image/sosmed/instagram.png'
import Lnk from '../../assets/image/sosmed/linkedin.png'
import Twit from '../../assets/image/sosmed/twitt.png'
import Chevron from '../../assets/image/chevron-white.png'

// import {Button} from '@material-ui/core'
import {LinkedinShareButton,FacebookShareButton,TwitterShareButton,
    FacebookIcon,
    LinkedinIcon,
    TwitterIcon
} from 'react-share'
import './css/detail.css'
import {Button} from '@material-ui/core'
import insight1 from '../../assets/image/insight1.jpg'
import insight2 from '../../assets/image/insight2.jpg'
import insight3 from '../../assets/image/insight3.jpg'
import insight4 from '../../assets/image/insight4.jpg'
import {data_insight} from '../../dummy/data'
import {Helmet} from "react-helmet";
import MetaTags from 'react-meta-tags';
let footer=(link)=>{
    return(
        <Button style={{textTransform:'none',fontWeight:'bold',padding:0}} color="primary" onClick={()=>window.location.assign(link)}>Read more </Button>
    )
}
  

export default class detail_insight extends Component {
    state={
        insight:null ,
        next_insight:[]
    }
    componentDidMount(){
        let detail=data_insight.filter((data)=>{
            return data.slug===this.props.match.params.slug
        })
        let next_insight=data_insight.filter((data)=>{
            return data.slug!==this.props.match.params.slug
        })
        let new_next=[]
        // console.log('jahe',window.location.href)
        next_insight.map((data,i)=>{
            if(i<3){
                new_next.push(data)
            }
        })
        this.setState({insight:detail[0],new_insight:new_next})
    }
    render() {
        const {insight,new_insight}=this.state

        return (
            <div>
                
                <Navbar/>
                <br/><br/><br/><br/>
                {insight!==null&&
                <section className='detail-insight'>
                     {/* <MetaTags>
                        <title>hehe</title>
                        <meta name="description" content={insight.preview.substring(0,99)} />
                        <meta property="og:title" content={insight.title} />
                        <meta property="og:image" content={`http://gmlperformance.com/static/media/${insight.img}`} />
                    </MetaTags> */}
                   <Helmet>
                        <meta charSet="utf-8" />
                        <title>{insight.title}</title>
                        <meta name="twitter:card" property="og:site_name" content={insight.preview.substring(0,99)} />
                        <meta property="og:title" content={insight.title} />
                        <meta property="og:image" content={`http://gmlperformance.com${insight.img}`} />
                    </Helmet>
                   
                    <div className='detail-overlay'>
                        <img src={insight.img}/>
                        <div className='detail-caption'>
                            <div className='badge'>
                                <p ><span style={{cursor:'pointer'}} onClick={()=>window.location.assign('/publication/insight')}>Insight</span> &nbsp;&nbsp;<span><img src={Chevron}  className='breadcrum-chevron-event'/></span>&nbsp;&nbsp;{insight.title}</p>
                                
                            </div>
                            <div className='detail-title'>
                                <h1>{insight.title}</h1>
                                <br/>
                                <p>{insight.date}</p>
                            </div>
                            
                        </div>
                    </div>
                    <br/>
                    <div className='content-insight'>
                        <div className='content-sub'>
                            <p>{insight.subtitle}</p>
                            <div style={{display:'flex'}}>
                                <h6>Share it:</h6>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <LinkedinShareButton url={window.location.href}>
                                    <img src={Lnk} style={{width:20,cursor:'pointer'}}/>

                                </LinkedinShareButton>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <TwitterShareButton url={window.location.href}>
                                    <img src={Twit} style={{width:20,cursor:'pointer'}}/>

                                </TwitterShareButton>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <FacebookShareButton url={window.location.href}>
                                <img src={Fb} style={{width:20,cursor:'pointer'}}/>

                                </FacebookShareButton>
                            </div>
                        </div>
                        <br/>
                        <hr/>
                        <br/>
                        <div className='content-detail'>
                           <div dangerouslySetInnerHTML={{__html: insight.content}}/>
                           
                           
                        </div>
                        <div style={{borderBottom:'1px dashed #777777'}}></div>
                        <br/>

                    </div>
                    <div className='insight-preview'>
                    <div className='insight-detail-grid'>
                        <div className='insight-detail-grid-khusus' >
                            <h2>Insight</h2>
                            &nbsp;&nbsp;&nbsp;
                            <div style={{width:1,height:20,backgroundColor:'#464646'}}></div>
                            &nbsp;&nbsp;&nbsp;
                            <p>More Insight</p>
                            {/* <Button style={{textTransform:'none',fontWeight:'bold'}} color="primary" onClick={()=>window.location.assign('/publication/insight')}>More insight </Button> */}
                        </div>
                        {new_insight.map((data,i)=>(
                        <div key={i} style={{boxShadow:'0 0 15px 0 rgba(37, 37, 37, 0.16)'}} onClick={()=>window.location.assign(`${data.link}/${data.slug}`)}>
                            <div className='overlay-small-insight-preview'>
                                <img src={data.img} alt="insight" className="img-box-small-insight-preview"  />
                                <div className='card-insight-preview'>
                                        <h6>{data.subtitle}</h6>
                                        <h3>{data.title}</h3>
                                        <div className='grid2-footer'>
                                        <Button style={{textTransform:'none'}} color="primary" onClick={()=>window.location.assign(`${data.link}/${data.slug}`)}>Read more </Button>
                                        </div>
                                        
                                </div>
                            </div>
                        </div>    
                        ))}
                        
                       
                    </div>
                    </div>
                   {/* <div className='insight-preview'>
                    <div className='insight-detail-grid'>
                        <div className='insight1'>
                            <h2>Insight</h2>
                            &nbsp;&nbsp;&nbsp;
                            <div style={{width:1,height:20,backgroundColor:'#464646'}}></div>
                            &nbsp;&nbsp;&nbsp;
                            <p>More Insight</p>
                        </div>
                        <div className='insight2'>
                            <div className='overlay-small-insight-preview'>
                                <img src={insight2} alt="insight" className="img-box-small-insight-preview"  />
                                <div className='card-insight-preview'>
                                        <h6>Consulting</h6>
                                        <h3>Belajar dari Jam Dinding dan Cermin</h3>
                                        <Button style={{textTransform:'none'}} color="primary">Read more </Button>
                                </div>
                            </div>
                        </div>
                        <div className='insight3'>
                            <div className='overlay-small-insight-preview'>
                            <img src={insight3} alt="insight" className="img-box-small-insight-preview"/>
                            <div className='card-insight-preview'>
                                    <h6>Consulting</h6>
                                    <h3>Mengelola dan Memonitor Perusahaan Multi Bisnis</h3>
                                    <Button style={{textTransform:'none'}} color="primary">Read more </Button>
                            </div>
                            </div>
                        </div>
                        <div className='insight4'>
                            <div className='overlay-small-insight-preview'>
                            <img src={insight4} alt="insight" className="img-box-small-insight-preview"/>
                            <div className='card-insight-preview'>
                                    <h6>Consulting</h6>
                                    <h3>THE DEATH OF TRANSACTIONAL LEADERSHIP?</h3>
                                    <Button style={{textTransform:'none'}} color="primary">Read more </Button>
                            </div>
                            </div>
                        </div>
                    </div>

                    </div> */}
                </section>
                }
                <br/>
                <Footer/>
            </div>
        )
    }
}
